import Button from "@mui/material/Button";
import { NON_CATALOGUE_ITEM, SMART_FORM } from "constants/generalConstants";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { closeSmartFormsDialogue } from "utils/smartFormsUtils";

import {
    setSupplierName,
    setSupplierSite,
    setWholeLine,
} from "../../redux/actions/createRequisitionActions";
import { primaryButtonSx } from "../../styled/styledSXProperties/styledButtonSX";
import alertDispatcher from "../../utils/alertsUtils";
import {
    closeNonCatDialogue,
    injectNonCatItemToReqLine,
    validNonCatItemInjection,
} from "../../utils/nonCatFormUtils";

const UpdateRequisitionLineButton = ({
    nonCat,
    product,
    reqLineIndex,
    nonCatFormValidator,
    informationTemplates = null,
}) => {
    // Collect states and state dispatchers
    const reqLines = useSelector(
        (state) => state.createRequisition.iBuyRequisition.requisitionLines
    );
    const req = useSelector((state) => state.createRequisition.iBuyRequisition);
    const dispatch = useDispatch();

    const clickUpdateReqLine = (event) =>
        nonCatFormValidator(() => updateReqLine())(event);

    const updateReqLine = () => {
        /* Two routes:
        1) User updates req line successfully successfully
        2) User unable to update item to cart as supplier validation rules violated.
        */
        const [isInjectionValid, errorMessage] = validNonCatItemInjection(
            product,
            req
        );
        if (isInjectionValid) {
            // Route 1 (see above)
            const updatedLine = injectNonCatItemToReqLine(
                reqLines[reqLineIndex],
                product
            );
            // TODO - align schemas so below duplicate fields do not require setting
            dispatch(
                setWholeLine(reqLineIndex, {
                    ...updatedLine,
                    SUGGESTED_VENDOR_ID: updatedLine.SUPPLIER_ID,
                    SUGGESTED_VENDOR_SITE_ID: updatedLine.SUPPLIER_SITE_ID,
                    ...(informationTemplates && {
                        INFORMATION_TEMPLATES: informationTemplates,
                    }),
                })
            );
            dispatch(setSupplierName(updatedLine.SUPPLIER_NUMBER_NAME));
            dispatch(setSupplierSite(updatedLine.SUPPLIER_SITE_ID));
            nonCat == NON_CATALOGUE_ITEM && closeNonCatDialogue(dispatch);
            nonCat == SMART_FORM && closeSmartFormsDialogue(dispatch);
        } else {
            // Route 2 (see above)
            alertDispatcher("updateReqLine", "400", dispatch, errorMessage);
        }
    };
    return (
        <Button
            onClick={clickUpdateReqLine}
            variant="contained"
            sx={primaryButtonSx}
        >
            Update Requisition Line
        </Button>
    );
};

UpdateRequisitionLineButton.propTypes = {
    nonCat: PropTypes.string,
    product: PropTypes.object,
    index: PropTypes.number,
    nonCatFormValidator: PropTypes.func,
    informationTemplates: PropTypes.object,
};

UpdateRequisitionLineButton.defaultProps = {
    informationTemplates: null,
};

export default UpdateRequisitionLineButton;
